<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="TagsEditor"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <DIV
    class="overflow-auto h-100 p-3"
  >
    <ItpDataTable
      tableId="Settings.TagsEditor"
      editable
      :value="items"
      :columns="b_8564662037462133_columns"
      class="h-100"
      ref="table"
      v-if="loaded"
      @save="evh_8564662037462133_save($event, {})"
      @delete="evh_8564662037462133_delete($event, {})"
    >
    </ItpDataTable>
  </DIV>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "settings.tagsEditor",
    path: "tags",
    component: "TagsEditor"
  }
)

@Component()
export default class TagsEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  tagTypes!: any;

  async $$load_tagTypes() {
    return this.$fn.fetch('list_tag_types')
  }

  items!: any;

  async $$load_items() {
    return this.$fn.fetch('get_tags', { parameters: { tag_type: '*' } })
      .then(data => _.flatten(_.values(data)))
      .then(p => _.map(p, pp => _.extend(pp, {
        id: `${pp.tag_type}:${pp.name}`
      })))
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_8564662037462133_columns!: any;

  async $$load_b_8564662037462133_columns() {
    return [{
      name: "tag_type",
      type: "select",
      header: this.$fn.pgettext("Tag", "Type"),
      width: "200px",
      required: true,
      options: this.tagTypes,
      valueField: "value",
      textField: "name",
    }
      ,
    {
      name: "name",
      header: this.$fn.pgettext("Tag", "Name"),
      width: "200px",
      required: true,
    }
      ,
    ]
  }

  dataMembers = ['tagTypes', 'items', 'ux', 'b_7315092382398562_modalBindings', 'b_8564662037462133_columns'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        tagTypes: null,
        items: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_8564662037462133_columns: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return
    }
    return null;
  }

  async act_7315092382398562_closeModal_5562_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_5562, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_script_5564_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8564662037462133_script_5564, alias=undefined
    $event.data.waitFor(this.$fn.crud('tag').upsert({ ...$event.data.row }))
  }

  async act_8564662037462133_script_5564_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8564662037462133_script_5564, alias=undefined
    return {
      value: () => this.act_8564662037462133_script_5564_getActionArgs_value($event),
    }
  }

  async evh_8564662037462133_save(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_save.executeFromDOM(this, event, scope);
  }

  async act_8564662037462133_script_5566_getActionArgs_value($event: actions.ActionEvent) {
    // callableMethod act_8564662037462133_script_5566, alias=undefined
    $event.data.waitFor(this.$fn.crud('tag').delete({ ...$event.data.row }))
  }

  async act_8564662037462133_script_5566_getActionArgs($event: actions.ActionEvent): Promise<actions.ScriptActionArgs> {
    // parameterResolver name=act_8564662037462133_script_5566, alias=undefined
    return {
      value: () => this.act_8564662037462133_script_5566_getActionArgs_value($event),
    }
  }

  async evh_8564662037462133_delete(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8564662037462133_delete.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_5562: actions.CloseModalAction;
    evh_7315092382398562_close_5561: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8564662037462133_script_5564: actions.ScriptAction;
    evh_8564662037462133_save_5563: actions.EventHandlerImpl;
    evh_8564662037462133_save: actions.EventHandlerGroup;
    act_8564662037462133_script_5566: actions.ScriptAction;
    evh_8564662037462133_delete_5565: actions.EventHandlerImpl;
    evh_8564662037462133_delete: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_5562 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_5562_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_5561 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_5562,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_5561],
      }
    );
    const act_8564662037462133_script_5564 = new actions.ScriptAction(
      {
        actionArgs: this.act_8564662037462133_script_5564_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_save_5563 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_script_5564,
        event: "save",
        displayName: "script",
      }
    );
    const evh_8564662037462133_save = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_save_5563],
      }
    );
    const act_8564662037462133_script_5566 = new actions.ScriptAction(
      {
        actionArgs: this.act_8564662037462133_script_5566_getActionArgs,
        events: [],
      }
    );
    const evh_8564662037462133_delete_5565 = new actions.EventHandlerImpl(
      {
        action: act_8564662037462133_script_5566,
        event: "delete",
        displayName: "script",
      }
    );
    const evh_8564662037462133_delete = new actions.EventHandlerGroup(
      {
        handlers: [evh_8564662037462133_delete_5565],
      }
    );
    return {
      act_7315092382398562_closeModal_5562,
      evh_7315092382398562_close_5561,
      evh_7315092382398562_close,
      act_8564662037462133_script_5564,
      evh_8564662037462133_save_5563,
      evh_8564662037462133_save,
      act_8564662037462133_script_5566,
      evh_8564662037462133_delete_5565,
      evh_8564662037462133_delete,
    }
  }
}

Vue.component("TagsEditor", TagsEditor);

</script>